/*
Crea o Modifica Reserva
*/
import Client from '../interfaces/Client'
import Reservation from '../interfaces/Reservation'
import Vehicle from '../interfaces/Vehicle'

import { ReservationNvvEdit } from './ReservationNvvEdit'

const ReservationEdit: React.FC<{ vehicle: Vehicle; client: Client; reservation?: Reservation }> = ({
  vehicle,
  client,
  reservation,
}) => {
  return <ReservationNvvEdit vehicle={vehicle} client={client} reservation={reservation} nvvInd={0} />
}

export default ReservationEdit
